module.exports = normalisePrograms
function normalisePrograms (user) {
  if (user.programs) {
    return user.programs
  }

  const isShelfLifeUser = user.roles && user.roles.find(role => role === 'shelflife-user')
  // for shelflife users without programs
  if (isShelfLifeUser) {
    return ['program:shelflife']
  }

  // worse case scenario
  return []
}
